// TODO - REMOVE THIS AND USE ? operator - THIS WAS COPIED FROM @component/common/src/util/ObjectUtil
export default {
  // Public method to get deep nested property value when property path is string.
  //
  // > parameters
  // >
  // + *obj* - *Object* Object that will looked for a particular property
  // + *propPath* - *String* Property path to look
  //
  // > returns
  // >
  // + *value* - will return whatever is the value of the property
  //
  getChildProperty(object, pPath) {
    let propPath = pPath;
    let obj = object;
    let i = 0;
    let part;

    if (!obj || typeof obj !== 'object' || !propPath || typeof propPath !== 'string') {
      // don't know what to return here because property can have any type of value undefined, false, etc...
      // may be we should just throw an error. or some random string to indicate an error
      return undefined;
    }

    // convert indexes to properties for example [0] will become .0
    propPath = propPath.replace(/\[(\w+)\]/g, '.$1');
    // strip a leading dot
    propPath = propPath.replace(/^\./, '');
    const path = propPath.split('.');
    const { length } = path;

    for (; i < length; i++) {
      part = path[i];
      if (obj && typeof obj === 'object' && part in obj) {
        obj = obj[part];
      } else {
        return undefined;
      }
    }
    return obj;
  },
};
